module.exports = __webpack_public_path__ + "img/morenlou.5354a080.png";